import React from "react"
import { withSpecialOpenHours } from "./withSpecialOpenHours"
import { Modal, ModalOpenButton, ModalContentsWithLayout } from "../Modal/Modal"
import { UnderlinedButton } from "../Styled/Button"
import { Title, OpenHours } from "./SpecialOpenHoursStyle"

export const SpecialOpenHours = withSpecialOpenHours(({ specialOpeningHours, additionalSpecialOpeningHoursButtonText }) => (
  <Modal>
    <ModalOpenButton>
      <UnderlinedButton size="primary" noMargin>
        <span>{additionalSpecialOpeningHoursButtonText}</span>
      </UnderlinedButton>
    </ModalOpenButton>
    <ModalContentsWithLayout layout={"special"}>
      <Title>{additionalSpecialOpeningHoursButtonText}</Title>
      <OpenHours>{specialOpeningHours}</OpenHours>
    </ModalContentsWithLayout>
  </Modal>
))
